<template>
  <b-modal
    title="Struktura"
    v-model="showModal"
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @ok.prevent="addTreeStruct"
    @hidden="$emit('cancel')"
  >
    <v-jstree :data="items" :async="loadData" show-checkbox whole-row @item-click="itemClick"></v-jstree>
  </b-modal>
</template>

<script>
import VJstree from 'vue-jstree';
import { EquipmentResource } from '@/resources/equipment.resource';
import { LogicalStructureResource } from '@/resources/logicalStructure.resource';

export default {
  components: {
    VJstree
  },
  props: {
    show: Boolean,
    item: Object
  },
  data() {
    return {
      nodeId: null,
      showModal: false,
      items: []
    };
  },
  methods: {
    itemClick(node) {
      this.nodeId = node.model.id;
    },
    async addTreeStruct() {
      try {
        const selectedTreeStruct = await EquipmentResource.assignStruct(this.item.id, this.nodeId);
        this.$notify({ type: 'success', text: 'Pomyślnie przypisano przedmiot', title: 'Sukces' });
        this.$emit('tree', selectedTreeStruct);
      } catch (error) {
        this.$notify({ type: 'error', text: 'Wystąpił błąd podczas przypisywania przedmiotu do struktury', title: 'Błąd' });
      }
    },
    async loadData(selectedNode, resolve) {
      try {
        const logicalStructure = await (selectedNode.data && selectedNode.data.id ? LogicalStructureResource.children(selectedNode.data.id) : LogicalStructureResource.fullList());
        const treeData = logicalStructure.map(item => ({ id: item.id, text: item.name, isLeaf: !item.hasChildren, selected: this.item.node && item.id === this.item.node.id }));
        resolve(treeData);
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    }
  },
  beforeMount() {
    this.showModal = this.show;
  }
};
</script>

<style></style>
